/* Functions here is to handle everything about
 * localStorage, sessionStorage or cookie
 */
import { SESSION, SHARED } from '@/constants'

export function getUserEmail() {
  let email = localStorage.getItem(SESSION.USER_EMAIL)

  if (email) {
    return email;
  } else {
    return '';
  }

}

export function getUserId() {
  return localStorage.getItem(SESSION.USER_ID)
}

export function getUserName() {
  return localStorage.getItem(SESSION.USER_NAME)
}

export function getUserToken() {
  return localStorage.getItem(SESSION.JWT_TOKEN)
}

export function getUserType() {
  return localStorage.getItem(SESSION.USER_TYPE)
}

export function getUserPermissions() {
  return localStorage.getItem(SESSION.PERMISSIONS)
}

export function getUserExpiredTime() {
  return localStorage.getItem(SESSION.TOKEN_EXPIRY_TIME)
}

export function getUserRefreshExpiredTime() {
  return localStorage.getItem(SESSION.REFRESH_TOKEN_EXPIRY_TIME)
}


export function clearAllClientStorage() {
  localStorage.clear()
  sessionStorage.clear()
}

export function isTokenExpired() {
  let result = false
  let tokenExpiry = localStorage.getItem(SESSION.TOKEN_EXPIRY_TIME)

  if (tokenExpiry && !isNaN(Date.parse(tokenExpiry))) {
    let currentTime = new Date();
    tokenExpiry = new Date(tokenExpiry);

    // Subtract 3 minutes (in milliseconds) from the token expiry time
    tokenExpiry.setMinutes(tokenExpiry.getMinutes() - 3);
    result = currentTime >= tokenExpiry;
  }
  else {
    result = true;
  }

  return result
}

export function isRefreshTokenExpired() {
  let result = false;
  let tokenExpiry = localStorage.getItem(SESSION.REFRESH_TOKEN_EXPIRY_TIME);

  if (tokenExpiry && !isNaN(Date.parse(tokenExpiry))) {
    let currentTime = new Date();
    tokenExpiry = new Date(tokenExpiry);

    // Subtract 3 minutes (in milliseconds) from the token expiry time
    tokenExpiry.setMinutes(tokenExpiry.getMinutes() - 3);
    result = currentTime >= tokenExpiry;
  }
  else {
    result = true;
  }

  return result;
}

export function isStaffTokenExpired() {
  let result = false
  let tokenExpiry = localStorage.getItem(SESSION.STAFF_TOKEN_EXPIRY_TIME)

  if (tokenExpiry && !isNaN(Date.parse(tokenExpiry))) {
    let currentTime = new Date();
    tokenExpiry = new Date(tokenExpiry);

    // Subtract 3 minutes (in milliseconds) from the token expiry time
    tokenExpiry.setMinutes(tokenExpiry.getMinutes() - 3);
    result = currentTime >= tokenExpiry;
  }
  else {
    result = true;
  }

  return result
}

export function isStaffRefreshTokenExpired() {
  let result = false;
  let tokenExpiry = localStorage.getItem(SESSION.STAFF_REFRESH_TOKEN_EXPIRY_TIME);

  if (tokenExpiry && !isNaN(Date.parse(tokenExpiry))) {
    let currentTime = new Date();
    tokenExpiry = new Date(tokenExpiry);

    // Subtract 3 minutes (in milliseconds) from the token expiry time
    tokenExpiry.setMinutes(tokenExpiry.getMinutes() - 3);
    result = currentTime >= tokenExpiry;
  }
  else {
    result = true;
  }

  return result;
}

// export function isTokenExpired() {
//   let result = false
//   let tokenExpiry = localStorage.getItem(SESSION.TOKEN_EXPIRY_TIME)

//   if (tokenExpiry && !isNaN(Date.parse(tokenExpiry))) {
//     let currentTime = new Date().toLocaleString() //Refresh token 3min before token expired
//     tokenExpiry = new Date(tokenExpiry).toLocaleString();
//     result = tokenExpiry <= currentTime
//   }

//   return result
// }

// export function isRefreshTokenExpired() {
//   let result = false
//   let tokenExpiry = localStorage.getItem(SESSION.REFRESH_TOKEN_EXPIRY_TIME)

//   if (tokenExpiry && !isNaN(Date.parse(tokenExpiry))) {
//     let currentTime = new Date().toLocaleString() //Refresh token 3min before token expired
//     tokenExpiry = new Date(tokenExpiry).toLocaleString();
//     result = tokenExpiry <= currentTime
//   }

//   return result
// }

export function calculateTime(seconds) {
  
  var currentDate = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Kuala_Lumpur" }));
  var expiredSeconds = parseInt(seconds); 
  
  // Get the current time in seconds
  var currentDateSeconds = currentDate.getSeconds();
  
  // Add expired seconds to the current time
  currentDate.setSeconds(currentDateSeconds + expiredSeconds);    
  
  return currentDate;
}

export function hasAuthToken() {
  let result = false

  if (getUserToken()) {
    result = true
  }

  return result
}

export function isActiveUser() {
  let result = false
  let lastActivityTime = localStorage.getItem(SESSION.LAST_ACTIVITY_TIME)

  if (lastActivityTime) {
    result = new Date().getTime() - parseInt(lastActivityTime) < SHARED.USER_IDLE_TIME
  }

  return result
}

/* START Search Criteria */
export function storeSearch(name, value) {
  let str = typeof value === 'string' ? value : JSON.stringify(value)
  sessionStorage.setItem(name, str)
}

export function retrieveSearch(name) {
  let f = sessionStorage.getItem(name)
  let result = f != undefined && f != null && f != '' ? JSON.parse(f) : ''
  
  return result
}

//need this when page refresh
export function clearSearch(name) {
  sessionStorage.removeItem(name)
}

export function hasSearchCriteria(name) {
  let f = sessionStorage.getItem(name)
  return f != undefined && f != null && f != ''
}

export function getStaffUserId() {
  return localStorage.getItem(SESSION.STAFF_USER_ID)
}

export function getStaffUserName() {
  return localStorage.getItem(SESSION.STAFF_USER_NAME)
}

export function getStaffUserToken() {
  return localStorage.getItem(SESSION.STAFF_JWT_TOKEN)
}

export function getStaffUserExpiredTime() {
  return localStorage.getItem(SESSION.STAFF_TOKEN_EXPIRY_TIME)
}

export function getStaffUserRefreshExpiredTime() {
  return localStorage.getItem(SESSION.STAFF_REFRESH_TOKEN_EXPIRY_TIME)
}

export function getStaffUserImage() {
  return localStorage.getItem(SESSION.STAFF_USER_IMAGE)
}

export function getStaffCompanyName() {
  return localStorage.getItem(SESSION.STAFF_COMPANY_NAME)
}

export function getStaffCompanyUUID() {
  return localStorage.getItem(SESSION.STAFF_COMPANY_UUID)
}

export function getStaffLocationUUID() {
  return localStorage.getItem(SESSION.STAFF_LOCATION_UUID)
}

export function getStaffLocationName() {
  return localStorage.getItem(SESSION.STAFF_LOCATION_NAME)
}

/* END Search Criteria */

